import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Collect your data carefully, a lesson",
  "description": "",
  "published": "2011-10-03T00:00:00.000Z",
  "redirect_from": ["/blog/collect-your-data-carefully-a-lesson/swizec/2556"],
  "categories": "Comma-separated values, Data structure, Programming, python, Spreadsheet, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/Screen-Shot-2011-10-03-at-11.50.58-AM-300x185.png",
        "alt": null,
        "title": "Chunk of the spreadsheet"
      }}></img></p>
    <p>{`For the past couple of months I've been involved with an experiment that primarily involves taking a few moments every day to write down some numbers. I haven't gotten the clearance yet to quite say what exactly the data we are logging represents, but I can tell you about why I'm never again using `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Spreadsheet",
        "title": "Spreadsheet"
      }}>{`spreadsheets`}</a>{` to do this sort of stuff.`}</p>
    <p>{`Over the weekend I started working on producing some graphs and useful understandable data out of two months of spreadsheets. The summer ones.`}</p>
    <p>{`Turns out exporting to `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Comma-separated_values",
        "title": "Comma-separated values"
      }}>{`CSV`}</a>{` then trying to import into a processable python data structure is less than easy when your tables were designed so that they look good as tables, are easy for humans to use and make sense when you look at them. The problem with python's handling of CSV is that it doesn't have any idea what my data actually looks like so it just produces a list of lists with values of all the cells.`}</p>
    {
      /*more*/
    }
    <p>{`My problem was that we were collecting three values for every day ... but until about a month in, we were only collecting two values. On top of that six rows translate into what is actually a single row of data with a certain range of values. In a table it's easier for people to use as six rows, but trying to draw a graph from that ... well you'd want a single row.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/Screen-Shot-2011-10-03-at-11.50.58-AM.png",
        "alt": null,
        "title": "Chunk of the spreadsheet"
      }}></img></p>
    <p>{`After quite a bit of muscling around and playing with more list comprehensions than fit comfortably in my head, that same data looks like this and is much more manageable.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`{'A': [[2, 3, -1], [3, 1, -1], [2, 2, -1], [2, 0, -1], [1, 0, -1], ...],
'B': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, ...]
'C': [0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, ...], }
`}</code></pre>
    <p>{`It pains me to admit it, but it took much too long to write a lens between the spreadsheet data and the data structure I can now actually use. Don't do this to yourselves and just make sure that whenever you are collecting data for a long lasting experiment, write some sort of easy interface that pops values right into the database.`}</p>
    <p>{`It will make your life easier.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://pandas.sourceforge.net/index.html"
        }}>{`pandas: powerful Python data analysis toolkit - pandas v0.4.0dev documentation`}</a>{` (pandas.sourceforge.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://onlinelabor.blogspot.com/2011/10/all-public-government-data-should-be.html"
        }}>{`It shouldn't take 64 lines of code to do something really simple`}</a>{` (onlinelabor.blogspot.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.policymap.com/blog/2011/09/did-you-know%25e2%2580%25a6-the-tables-feature/"
        }}>{`Did you know... (The Tables Feature)`}</a>{` (policymap.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=6763b2a6-71a6-4197-ac66-b441664e2bfc",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      